import { connect } from "react-redux";

import AnswerOther from "components/answer/AnswerOther";

import history from "utils/history";

import { setNextPage, setPrevPage } from "redux/modules/answer/answerOther";
import { changeFreeCommentText } from "redux/modules/answer/answerResult";
import { openErrorDialog } from "redux/modules/errorDialog";
import axios from "axios";
import { baseApiUrl } from "../../api";
import { pathRole } from "../../utils/formatter";
import { setAuthErrorType } from "redux/modules/answer/answerLogin";
import { answerLoginURL } from "utils/formatter";

const mapStateToProps = state => {
  const { currentPage, freeCommentDescriptions } = state.answerOther;

  // 自由記入の説明は配列で渡す
  const { freeComment1, freeComment2 } = state.answerResult;
  const freeComments = [freeComment1, freeComment2];

  // ボタンのラベルをページ数で切り替える
  let btnLabel = "";
  if (freeCommentDescriptions.length === 1) {
    btnLabel = "確認画面へ";
  } else {
    // 自由記入が２つの場合は、現在のページでボタンの文言を切り替える
    btnLabel = ["次へ", "確認画面へ"][currentPage];
  }

  const answerOther = {
    currentPage,
    freeCommentDescriptions,
    btnLabel
  };

  return {
    answerOther,
    freeComments,
    answerHeader: state.answerHeader,
    locale: state.answerResult.locale,
    answerQuestion: state.answerQuestion,
    answerStart: state.answerStart,
    isEffecting: state.answerHeader.isEffecting,
    locale: state.answerResult.locale,
    answerResult: state.answerResult
  };
};

const base = baseApiUrl();
const role = pathRole();

const mapDispatchToProps = (dispatch, ownProps) => ({
  // 自由記入が設定されていない場合は回答結果画面へ移動する
  moveResultPage: () => {
    history.push("/result", ownProps);
  },
  // テキストの変更
  changeFreeCommentText: (currentPage, text) => {
    const key = ["freeComment1", "freeComment2"][currentPage];
    dispatch(changeFreeCommentText(key, text));
  },
  // 次へ進むボタン
  handleNextBtn: answerOther => () => {
    const { currentPage, freeCommentDescriptions } = answerOther;

    // currentPageの初期値の0なので、1を足して判定する
    if (currentPage + 1 < freeCommentDescriptions.length) {
      // 次の自由記入を表示
      dispatch(setNextPage());
    } else {
      // 回答結果画面へ移動
      setTimeout(() => history.push("/result", ownProps), 300);
    }
  },
  // 前へ進むボタン
  handlePrevBtn: currentPage => () => {
    if (currentPage > 0) {
      // 前の自由記入を表示
      dispatch(setPrevPage());
    } else {
      // setTimeout(() => ownProps.history.goBack(), 300);
      setTimeout(() => history.push("/answer_question", ownProps), 300);
    }
  },
  // エラーの表示
  showErrorDialog: () => {
    dispatch(openErrorDialog(new Error("authError")));
  },
  startTemporarySave: params => {
    return axios({
       method: 'post',
       url: `${base}/${role}/survey_temp_save`,
       data: params
     })
       .then(res => {
         if (res.invalidStatusError) {
           dispatch(setAuthErrorType("canNotAnswer"));
           history.push(answerLoginURL(), ownProps);
         } 
         return res;
       })
       .catch(error => {
         dispatch(openErrorDialog(error));
         throw error;  // important for child .catch()
       });
   },
   confirmedTemporarySave: () => {
     window.location.reload();
   }
});

export default connect(mapStateToProps, mapDispatchToProps)(AnswerOther);



// WEBPACK FOOTER //
// ./src/containers/answer/AnswerOtherContainer.js